import { Component } from '@angular/core';
import { SkeletonBlock } from '../../../../shared/components/skeleton/skeleton-block';

/** Cost line placeholders in the desktop Get Labels estimate card. */
const GET_LABELS_DESKTOP_COST_LINE_COUNT = 6;
/** Cost line placeholders in the tablet estimate column (768pt prototype). */
const GET_LABELS_TABLET_COST_LINE_COUNT = 8;
/** Mobile success-notice copy line widths (390pt prototype). */
const GET_LABELS_MOBILE_NOTICE_WIDTHS = ['100%', '96%', '88%', '52%'] as const;
/** Mobile label-card helper line widths. */
const GET_LABELS_MOBILE_HELPER_WIDTHS = ['100%', '96%', '46%'] as const;
/** Tablet success-notice copy line widths. */
const GET_LABELS_TABLET_NOTICE_WIDTHS = ['96%', '44%'] as const;

/**
 * Get Labels content skeleton (OM-715).
 * Desktop mirrors `skelLabels`; tablet matches 768pt body plus shared footer actions; mobile 390pt.
 */
@Component({
  selector: 'app-get-labels-skeleton',
  imports: [SkeletonBlock],
  templateUrl: './get-labels-skeleton.html',
  styleUrl: './get-labels-skeleton.scss',
})
export class GetLabelsSkeleton {
  protected readonly desktopCostLinePlaceholders = Array.from(
    { length: GET_LABELS_DESKTOP_COST_LINE_COUNT },
    (_, index) => index,
  );

  protected readonly tabletCostLinePlaceholders = Array.from(
    { length: GET_LABELS_TABLET_COST_LINE_COUNT },
    (_, index) => index,
  );

  protected readonly mobileNoticeLineWidths = GET_LABELS_MOBILE_NOTICE_WIDTHS;
  protected readonly mobileHelperLineWidths = GET_LABELS_MOBILE_HELPER_WIDTHS;
  protected readonly tabletNoticeLineWidths = GET_LABELS_TABLET_NOTICE_WIDTHS;
}
